import React, { useState } from 'react';
import { IoIosArrowBack } from 'react-icons/io';
import { IoIosArrowForward } from 'react-icons/io';
import { BsDot } from 'react-icons/bs';
import './style.css';

export default function Pagination({ pages, page, setPage }) {
  const length = pages.totalPages;
  const pagesArray = Array.from({ length });
  const [goToPageValue, setGoToPageValue] = useState('');
  
  // console.log('📊 Pagination component - pages:', pages, 'page:', page, 'length:', length);

  const handleNext = () => {
    if (length > page) {
      setPage(page + 1);
    }
  };

  const handlePrev = () => {
    if (page !== 1) {
      setPage(page - 1);
    }
  };

  const updatePage = val => {
    console.log('🔘 Pagination clicked - Setting page to:', val);
    setPage(val);
  };

  const handleGoToPage = () => {
    const pageNumber = parseInt(goToPageValue);
    if (pageNumber >= 1 && pageNumber <= length) {
      setPage(pageNumber);
      setGoToPageValue('');
    }
  };

  const handleGoToPageKeyPress = e => {
    if (e.key === 'Enter') {
      handleGoToPage();
    }
  };

  const handleGoToPageChange = e => {
    const value = e.target.value;
    // Only allow numbers and limit to max pages
    if (value === '' || (Number.isInteger(Number(value)) && Number(value) >= 1 && Number(value) <= length)) {
      setGoToPageValue(value);
    }
  };

  return (
    <div className="pagination_row">
      <div className="pagination_box">
        <IoIosArrowBack className="next_prev_icon" onClick={() => handlePrev()} />
        {length <= 5 ? (
          pagesArray.map((item, index) => {
            return (
              <div
                key={index + 1}
                className={index + 1 === page ? 'active_page' : 'page'}
                onClick={() => updatePage(index + 1)}
              >
                {index + 1}
              </div>
            );
          })
        ) : (
          <>
            <div className={page === 1 ? 'active_page' : 'page'} onClick={() => updatePage(1)}>
              1
            </div>
            <div className={page === 2 ? 'active_page' : 'page'} onClick={() => updatePage(2)}>
              2
            </div>

            {page === 3 ? (
              <>
                <div className="active_page" onClick={() => updatePage(3)}>
                  3
                </div>
                <div className="page" onClick={() => updatePage(4)}>
                  4
                </div>
              </>
            ) : page > 4 && page !== length - 1 && page !== length ? (
              <>
                <div className="dots_row">
                  <BsDot className="dots" />
                  <BsDot className="dots" />
                  <BsDot className="dots" />
                </div>
                <div className="active_page" onClick={() => updatePage(page)}>
                  {page}
                </div>
              </>
            ) : page <= 4 ? (
              <>
                <div className="page" onClick={() => updatePage(3)}>
                  3
                </div>
                <div className={page === 4 ? 'active_page' : 'page'} onClick={() => updatePage(4)}>
                  4
                </div>
              </>
            ) : (
              <>
                <div className="dots_row">
                  <BsDot className="dots" />
                  <BsDot className="dots" />
                  <BsDot className="dots" />
                </div>
                <div className="page" onClick={() => updatePage(length - 2)}>
                  {length - 2}
                </div>
              </>
            )}

            {page === length - 1 ? (
              <div className="active_page" onClick={() => updatePage(length - 1)}>
                {length - 1}
              </div>
            ) : page >= length - 2 ? (
              <div className="page" onClick={() => updatePage(length - 1)}>
                {length - 1}
              </div>
            ) : (
              <>
                <div className="dots_row">
                  <BsDot className="dots" />
                  <BsDot className="dots" />
                  <BsDot className="dots" />
                </div>
              </>
            )}

            <div className={page === length ? 'active_page' : 'page'} onClick={() => updatePage(length)}>
              {length}
            </div>
          </>
        )}

        <IoIosArrowForward className="next_prev_icon" onClick={() => handleNext()} />
      </div>

      {length > 5 && (
        <div className="go_to_page_container">
          <span className="go_to_page_label">Go to:</span>
          <input
            type="text"
            className="go_to_page_input"
            value={goToPageValue}
            onChange={handleGoToPageChange}
            onKeyPress={handleGoToPageKeyPress}
            placeholder={`1-${length}`}
            maxLength={length.toString().length}
          />
          <button
            className="go_to_page_button"
            onClick={handleGoToPage}
            disabled={!goToPageValue || goToPageValue < 1 || goToPageValue > length}
          >
            Go
          </button>
        </div>
      )}
    </div>
  );
}
